export default __webpack_public_path__ + "static/media/Stats.e68ad4ce.svg";